import { GetAppointmentsRequest } from '../api/appointments';

export const querykeys = {
  appointments: {
    getAll: (i: GetAppointmentsRequest) => ['appointments', i],
  },
};
